const Blockly = require('blockly');
const { config } = require('@sstdev/lib_metadata-config');
const get = require('lodash/get');

// Override Blockly.serialization.workspaces.load to lazily convert deprecated
// blocks.
// The conversion portion typically takes <= 1ms, so lazily converting should
// be fine from a perf perspective.
const originalLoad = Blockly.serialization.workspaces.load;
Blockly.serialization.workspaces.load = function (xml, workspace) {
    descendAndConvertBlocks(xml.blocks.blocks[0]);
    return originalLoad(xml, workspace);
};

// Recursively checks each block to see if there is a matching hNodeTypeGroup and
// hNodeType in the config.blockConversions object. If there is, it updates the block's
// type to the new type.
function descendAndConvertBlocks(block) {
    if (block.type == null) {
        throw new Error('Block type is null');
    }
    const [oldHNodeTypeGroup, oldHNodeType] = block.type.split('_');
    const newType = get(config.blockConversions, [oldHNodeTypeGroup, oldHNodeType]);
    if (newType != null) {
        block.type = [newType.hNodeTypeGroup, newType.hNodeType ?? oldHNodeType].join('_');
    }
    if (block?.inputs?.children?.block != null) {
        descendAndConvertBlocks(block.inputs.children.block);
    }
    if (block?.next?.block != null) {
        descendAndConvertBlocks(block.next.block);
    }
}
